// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

const API_URL = 'https://api.zasway.com:8443'

const parseDispatchBookingDateTime = (bookingDate, bookingTime) => {
  if (!bookingDate || !bookingTime) return null

  const [day, month, year] = String(bookingDate).split('-')
  if (!day || !month || !year) return null

  const normalizedTime = String(bookingTime).trim()
  const meridiemMatch = normalizedTime.match(/\s(AM|PM)$/i)
  const timeParts = normalizedTime.replace(/\s(AM|PM)$/i, '').split(':')
  let hours = parseInt(timeParts[0], 10)
  const minutes = parseInt(timeParts[1], 10)

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null

  if (meridiemMatch) {
    const meridiem = meridiemMatch[1].toUpperCase()
    if (meridiem === 'PM' && hours < 12) hours += 12
    if (meridiem === 'AM' && hours === 12) hours = 0
  }

  const parsedDate = new Date(Number(year), Number(month) - 1, Number(day), hours, minutes, 0, 0)
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

const filterDispatchBookingsByTimeWindow = (bookings, startTime, endTime) => {
  if (!startTime || !endTime || !Array.isArray(bookings)) return bookings

  const startDateTime = new Date(startTime)
  const endDateTime = new Date(endTime)

  if (Number.isNaN(startDateTime.getTime()) || Number.isNaN(endDateTime.getTime())) return bookings

  return bookings.filter(booking => {
    const bookingDateTime = parseDispatchBookingDateTime(booking.bookingDate, booking.bookingTime)
    return bookingDateTime && bookingDateTime >= startDateTime && bookingDateTime <= endDateTime
  })
}

export const getZoneDistances_Time = createAsyncThunk('/DispatchBookings/getZoneDistances_Time',  (zoneDistances_time) => {
   
  return {data : zoneDistances_time}
   
  })
  export const getLongLat = createAsyncThunk('/DispatchBookings/getLongLat',  (getlonglat) => {
   
    return {data : getlonglat}
    
    })
    export const GetRemoteHistory = createAsyncThunk('appCreditCardsBooking/GetRemoteHistory', async (params) => {
 
      const response = await axios.post('https://api.zasway.com:8443/Booking/GetRemoteBookingHistoryLog', params, { mode: 'cors' })
       
      return response.data
    })
    export const ApproveRemoteHistory = createAsyncThunk('appCreditCardsBooking/ApproveRemoteHistory', async (params) => {
     
      const response = await axios.post('https://api.zasway.com:8443/Booking/ApproveRemoteBookingHistory', params, { mode: 'cors' })
       
      return response.data
    })
  export const addZonesToDB = createAsyncThunk('DispatchBookings/addZonesToDB ', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Zone/GetTableSummaryZones', params, { mode: 'cors' })
    
    return response.data
  })
  export const DriverLocation = createAsyncThunk('DispatchBookings/addZonesToDB ', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverLocation', params, { mode: 'cors' })
    
    return response.data
  })
  export const GetTrackingDriversLocation = createAsyncThunk('DispatchBookings/addZonesToDB ', async (params) => {
    
     
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetAllAvailableDriverListForTracking', params, { mode: 'cors' })
     
    return response.data
  })
  export const getBookingStartEndTime = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
 
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingStartEndTimeApiCall', params, { mode: 'cors' })
     
    return response.data
  })
export const getAllZones = createAsyncThunk('DispatchBookings/getAllZones ', async (params) => {
    
  const response = await axios.post('https://api.zasway.com:8443/Zone/GetTableSummaryZones', params, { mode: 'cors' })
   
  return {data: response.data}
})
export const getBookingTrackingDetails = createAsyncThunk('UpcomingBooking/getBookingdetails', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingTrackingDetails', params, { mode: 'cors' })

  return response.data
})

export const getBookingStatus = createAsyncThunk('UpcomingBooking/getBookingStatus', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingStatus', params, { mode: 'cors' })

  return response.data
})
export const getBooking_Journey = createAsyncThunk('/DispatchBookings/getBooking_Journey',  (bookingJourney) => {
      
  return {data : bookingJourney}
  })
  export const getDispatchActiveTab = createAsyncThunk('/DispatchBookings/getDispatchActiveTab',  (bookingJourney) => {
      
  return {data : bookingJourney}
  })
  export const getTrackingDriverLocation = createAsyncThunk('Booking/getTrackingDriverLocation ', async (params) => {
  
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverLocationForTracking', params, { mode: 'cors' })
   
    return response.data
  })
export const getDispatchDriversDetails = createAsyncThunk('Booking/getDispatchDriversDetails', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetDispatchDriverDetailsSumAvailability', params, { mode: 'cors' })
  
  return response.data[0]
})


export const rejectDriverRequest = createAsyncThunk('Booking/RejectDriverRequest ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/RejectDriverRequest', params, { mode: 'cors' })
  
  return response.data
})

export const UpdateBookingDriverAndVehicle = createAsyncThunk('Booking/UpdateBookingDriverAndVehicleUpdate ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingDriverAndVehicle', params, { mode: 'cors' })
 
  return response.data
})
export const UpdateBookingDriverAndVehicleHard = createAsyncThunk('Booking/UpdateBookingDriverAndVehicleUpdate ', async (params) => {
    
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingDriverAndVehicleHard', params, { mode: 'cors' })
   
  return response.data
})

export const UpdateBookingDriverAndVehicleHardSubContractor = createAsyncThunk('Booking/UpdateBookingDriverAndVehicleHardSubContractor ', async (params) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingDriverAndVehicleHardSubContractor', params, { mode: 'cors' })
 
  return response.data
})

export const getDriverAllocationSummary = createAsyncThunk('Booking/getDriverAllocationSummary ', async (params) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriverAllocation', params, { mode: 'cors' })
 
  return response.data
})

export const approveDriverAllocation = createAsyncThunk('Booking/approveDriverAllocation ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/ApproveDriverAllcation', params, { mode: 'cors' })
  
  return response.data
})

export const rejectDriverAllocation = createAsyncThunk('Booking/rejectDriverAllocation ', async (params) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Booking/RejectDriverAllcation', params, { mode: 'cors' })
 
  return response.data
})
 export const GetFindDriverWithSearch = createAsyncThunk('appBookingValidation/GetFindDriverDetail', async (GetDriver) => {
             
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetFindDriverDetail', GetDriver, {mode:'cors'})
            return response.data
  })
export const getDriverListDocumentExpiry = createAsyncThunk('Booking/getDriverListDocumentExpiry ', async (params) => {
  //
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryDriverListDocumentExpiry', params, { mode: 'cors' })
  //
  return response.data
})

export const getDriverSubContractor = createAsyncThunk('Booking/getDriverSubContractor ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryDriverSubContractor', params, { mode: 'cors' })
  
  return response.data
})

export const getBookingStatusList = createAsyncThunk('appCreditCardsBooking/getBookingStatusList', async () => {
  
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDispatchBookingStatusList')
   
  return response.data
})
export const getContactList = createAsyncThunk('appCreditCardsBooking/getContactList', async (params) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Common/GetDriverPassengercontactList', params, { mode: 'cors' })
   
  return response.data
})
export const getBookingStatusFilterList = createAsyncThunk('appCreditCardsBooking/getBookingStatusList', async () => {
const response = await axios.post('https://api.zasway.com:8443/Common/GetBookingStatusesList')
 
return response.data
})
export const getUpdateBookingStatus = createAsyncThunk('Booking/getUpdateBookingStatus ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/UpdateBookingStatus', params, { mode: 'cors' })
 
  return response.data
})
export const confirmDriverAllocationDispatch = createAsyncThunk('Booking/confirmDriverAllocationDispatch ', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/ConfirmDriverAllocationDispatch', params, { mode: 'cors' })
  
  return response.data
})
export const getBookingDriverUnallocated = createAsyncThunk('Booking/getBookingDriverUnallocated', async (params) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Booking/UnallocateBookingDriverAndVehicle', params, { mode: 'cors' })
   
  return response.data
})

// export const getDataBooking = createAsyncThunk('client/getDataBooking', async (params) => {

//   const response = await axios.post('https://api.zasway.com:8443/Booking/GetBooking', params, { mode: 'cors' })

//   return {
//     params,
//     data: response.data,
//     allData: response.data,
//     totalPages: 10
//   }
// })
export const getDataBookingsDispatch = createAsyncThunk('client/getDataBookingsDispatch', async (params) => {
  
  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingDispatch', params, { mode: 'cors' })
 
  return {
    params,
    data: response.data,
    allData: response.data,
    totalPages: 10
  }
})

export const getDataBookingDispatch = createAsyncThunk('DispatchBookings/getDataBookingDispatch', async (params) => {
       
    const response = await axios.post(`${API_URL}/Booking/GetTableSummaryDispatchBookingsTest`, params, {mode:'cors'})
    const filteredData = filterDispatchBookingsByTimeWindow(response.data, params.startTime, params.endTime)
      
    return {
      params,
      data: filteredData
      // allData: response.data.allData,
      // totalPages: response.data.total
    } 
})
export const getDataBookingDispatchParams = createAsyncThunk('/DispatchBookings/getDataBookingDispatchParams',  (dataParams) => {
       
  return {data : dataParams}
   
  })

export const getDataBookingDispatchParamsForActiveTab = createAsyncThunk('/DispatchBookings/getDataBookingDispatchParamsForActiveTab',  (dataParams) => {
       
  return {data : dataParams}
    
})

export const isMainSidebarActive = createAsyncThunk('/DispatchBookings/isMainSidebarActive',  (dataParams) => {
  return {isSidebarActive : dataParams.menuCollapsed}
    
})

export const getDataBooking2 = createAsyncThunk('client/getDataBooking', async (params) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBooking', params, { mode: 'cors' })
 
 return response.data
})
// export const getDataBooking3 = createAsyncThunk('client/getDataBooking', async (params) => {
 
//   const response = await axios.post('https://api.zasway.com:8443/Booking/GetBooking', params, { mode: 'cors' })

//   return {
//     params,
//     data: response.data,
//     allData: response.data,
//     totalPages: 10
//   }
// })
export const getSubCompanyList = createAsyncThunk('Client/getSubCompanyList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetSubCompanyList')
  return response.data
})

export const getPriorityLst = createAsyncThunk('client/getPriorityList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPriorityList')
  return response.data
})

export const getInvoicePeriodList = createAsyncThunk('Client/getInvoicePeriodList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoicePeriodList')
  return response.data
})

export const getInvoiceSplitList = createAsyncThunk('Client/getInvoiceSplitList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceSplitList')
  return response.data
})

export const getInvoiceGroupList = createAsyncThunk('Client/getInvoiceGroupList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetInvoiceGroupList')
  return response.data
})

export const getTaxList = createAsyncThunk('Client/getTaxList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList')
  return response.data
})

export const getPaymentMethodList = createAsyncThunk('Client/getPaymentMethodList', async (params) => {
  const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
  return response.data
})

export const getVehicleTypeList = createAsyncThunk('Client/getVehicleTypeList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, {mode: 'cors'})
  return response.data
})

export const getCurrencyList = createAsyncThunk('Client/getCurrencyList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetCurrencyList')
  return response.data
})

export const getPricingModalList = createAsyncThunk('Client/getPricingModalList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModalList')
  return response.data
})

export const getPricingModeList = createAsyncThunk('Client/getPricingModeList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPricingModeList')
  return response.data
})

export const getGraceWaitingList = createAsyncThunk('Client/getGraceWaitingList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetGraceWaitingList')
  return response.data
})

export const getDocumentTypeList = createAsyncThunk('Client/getDocumentTypeList', async () => {
  const response = await axios.get('https://api.zasway.com:8443/Common/GetDocumentTypeList')
  return response.data
})

export const getTagList = createAsyncThunk('Client/getTagList', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetTagList')
  return response.data
})

export const getClientList = createAsyncThunk('appPassenger/getClientList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList')
  return response.data
})

export const getPassengerList = createAsyncThunk('appPassenger/getPassengerList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList')
  return response.data
})

export const getDurationList = createAsyncThunk('appPassenger/getDurationList', async () => {

  const response = await axios.post('https://api.zasway.com:8443/Common/GetDurationList')
  return response.data
})
export const getFlightDetails = createAsyncThunk('appPassenger/getFlightDetails', async (id) => {

  const response = await axios.post('https://api.zasway.com:8443/FlightDetails/Get', id, { mode: 'cors' })

  return response.data
})

// export const getUser = createAsyncThunk('appUsers/getUser', async id => {
//   const response = await axios.get('https://api.zasway.com:8443/api/users/user', { id })
//   return response.data.user
// })
export const GetVehicle = createAsyncThunk('appDriver/GetVehicleList', async (GetVehicle) => {

  const response = await axios.post('https://api.zasway.com:8443/Vehicle/GetVehicleList', GetVehicle, { mode: 'cors' })

  return response.data
})
export const GetBooker = createAsyncThunk('appDriver/GetBookerList', async (GetBooker) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookerList', GetBooker, { mode: 'cors' })

  return response.data
})
export const GetExclusion = createAsyncThunk('appDriver/GetExclusionList', async (GetExclusion) => {

  const response = await axios.post('https://api.zasway.com:8443/Exclusion/GetExclusionList', GetExclusion, { mode: 'cors' })

  return response.data
})
export const getExpenseTypeList = createAsyncThunk('appDriver/getExpenseTypeList', async (GetExpenseTypeList) => {

  const response = await axios.post('https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeList', GetExpenseTypeList, { mode: 'cors' })

  return response.data
})
export const getBookingJourneyWaitTime = createAsyncThunk('appDriver/getBookingJourneyWaitTime', async (booking) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingJourneyWaitTime', booking, { mode: 'cors' })

  return response.data
})
export const getBookingExpense = createAsyncThunk('appDriver/getBookingExpense', async (GetExpenseList) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryBookingExpense', GetExpenseList, { mode: 'cors' })

  return response.data
})
export const getExpenseTypeTax = createAsyncThunk('appDriver/getExpenseTypeTax', async (GetExpenseTypeList) => {

  const response = await axios.post('https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeTax', GetExpenseTypeList, { mode: 'cors' })

  return response.data
})
export const getGetTagDetail = createAsyncThunk('appDriver/getGetTagDetail', async (tag) => {

  const response = await axios.post('https://api.zasway.com:8443/Tag/getGetTagDetail', tag, { mode: 'cors' })

  return response.data
})
export const getPassengerBookingHistory = createAsyncThunk('Client/GetPassengerBookingHistory', async (Passenger) => {

  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerBookingHistory', Passenger, { mode: 'cors' })

  return response.data
})

export const getPassengerNote = createAsyncThunk('Client/GetPassengerNote', async (Passenger) => {

  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerNote', Passenger, { mode: 'cors' })

  return response.data
})

export const getClientNote = createAsyncThunk('Client/GetClientNote', async (Client) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientNote', Client, { mode: 'cors' })

  return response.data
})
export const getBookingQuote = createAsyncThunk('Client/GetBookingQuote', async (Client) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingQuote', Client, { mode: 'cors' })

  return response.data
})

export const getBookingFormSetting = createAsyncThunk('Client/GetBookingFormSetting', async (booking) => {

  const response = await axios.post('https://api.zasway.com:8443/BookingFormSetting/GetBookingFormSetting', booking, { mode: 'cors' })

  return response.data
})

export const addBooking = createAsyncThunk('Client/Create', async (Booking) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/Create', Booking, { mode: 'cors' })

  return response
})
export const EditBooking = createAsyncThunk('Client/Edit', async (Booking) => {

  const response = await axios.post('https://api.zasway.com:8443/Booking/Update', Booking, { mode: 'cors' })

  return response
})

export const addDocument = createAsyncThunk('Client/CreateDocument', async (Document) => {

  const response = await axios.post('https://api.zasway.com:8443/Common/Create', Document, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }, { mode: 'cors' })

  return response
})

export const EditClient = createAsyncThunk('Client/Update', async (Client) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/Update', Client, { mode: 'cors' })

  return response
})

export const getAllData = createAsyncThunk('Client/GetTableSummary', async (GetClient) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', GetClient, { mode: 'cors' })

  return response.data
})

// export const getData = createAsyncThunk('Client/getData', async (params) => {

//   const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { mode: 'cors' })

//   return {
//     params,
//     data: response.data.data,
//     allData: response.data.allData,
//     totalPages: response.data.total
//   }
// })

// export const getClient = createAsyncThunk('Client/getClient', async (params) => {

//   const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummary', params, { mode: 'cors' })

//   return {
//     params,
//     data: response.data.data,
//     allData: response.data.allData,
//     totalPages: response.data.total
//   }
// })

export const getUser = createAsyncThunk('appUsers/getUser', async () => {

  const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {

  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, { headers }, { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteClient = createAsyncThunk('Client/Delete', async (id, { dispatch, getState }) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/Delete', id, { mode: 'cors' })

  await dispatch(getData(getState().clients.params))

  return response
})

export const getClientStats = createAsyncThunk('Client/GetClientStatistics', async (GetClient) => {

  const response = await axios.post('https://api.zasway.com:8443/Client/GetClientStatistics', GetClient, { mode: 'cors' })

  return response.data
})

export const getAPIKEY = createAsyncThunk('Client/getAPIKEY', async (params) => {
  //
  const response = await axios.post('https://api.zasway.com:8443/Configuration/GetConfigurationData', params, {mode:'cors'})
   
  return  response.data
     
 })
 export const getDistanceTimeStatesClear = createAsyncThunk('Client/getAPIKEY', async () => {

  return await true

 })
 // show advance filters start from here
 
 export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
            const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, {mode:'cors'})
            return response.data
  })
export const getPassengerListFilterWithSearchAgainstClient = createAsyncThunk('appBookingValidation/GetPassengerListAgainstClient', async (params) => {
    
  const response = await axios.post('https://api.zasway.com:8443/Common/getPassengerListFilterWithSearchAgainstClient', params, {mode: 'cors'})
    return response.data
  })
  export const GetDriverWithSearch = createAsyncThunk('appBookingValidation/GetDriverListWithSearch', async (GetDriver) => {
      
            const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverListWithSearch', GetDriver, {mode:'cors'})
            return response.data
  })
  
  export const getClientListFilterWithSearch = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientListWithSearch', params, {mode: 'cors'})
    return response.data
  })

  export const getPassengerListFilterWithSearch = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerListWithSearch', params, {mode: 'cors'})
    return response.data
  })
 
export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypeList', params, {mode: 'cors'})
    return response.data
  })
 
  export const getClientListFilter = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
    return response.data
  })
 
  export const getPassengerListFilter = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerList', params, {mode: 'cors'})
    return response.data
  })
 
// show advance filters ends here
export const BookingSlice = createSlice({
  name: 'client',
  initialState: {
    data: [],
    total: 0,
    params: {},
    allData: [],
    selectedUser: null,
    bookingJourney: null,
    zonesData: null,
    totalZoneDistances_time: null, 
    dispatchActiveTab: null, 
    dispatchActiveTab: null, 
    getlonglat: null, 
    RefreshConfirmedBooking: [],
    getBookingDispatchParams: null,
    CurrentTabStatus: null,
    Loader: false,
    PageCount: [],
    isSidebarActive: true
  },
  reducers: {},
  extraReducers: builder => {
    builder
    
    .addCase(getDistanceTimeStatesClear.fulfilled, (state) => {
      state.totalZoneDistances_time = null
     
      })
    .addCase(getZoneDistances_Time.fulfilled, (state, action) => {
       
      state.totalZoneDistances_time = action.payload.data
     
      }) 
      .addCase(getDispatchActiveTab.fulfilled, (state, action) => {
         
        state.dispatchActiveTab = action.payload.data
       
        }) 
      .addCase(getDataBookingDispatchParams.fulfilled, (state, action) => {
          
        state.getBookingDispatchParams = action.payload.data
        state.PageCount = action.payload.data
       
        }) 

      .addCase(getDataBookingDispatchParamsForActiveTab.fulfilled, (state, action) => {
         
        state.CurrentTabStatus = action.payload.data
        })  

      .addCase(isMainSidebarActive.fulfilled, (state, action) => {
        state.isSidebarActive = action?.payload?.isSidebarActive
      })  
  

      .addCase(getLongLat.fulfilled, (state, action) => {
        
        state.getlonglat = action.payload.data
       
        }) 
    .addCase(getAllZones.fulfilled, (state, action) => {
      state.zonesData = action.payload.data
      })
    .addCase(getBooking_Journey.fulfilled, (state, action) => {
       
      state.bookingJourney = action.payload.data
     
      }) 
      .addCase(getAllData.fulfilled, (state, action) => {
        
        state.allData = action.payload
      })
      // .addCase(getDataBooking.fulfilled, (state, action) => {
        
      //   state.data = action.payload.data
      //   state.allData = action.payload.allData
      //   state.total = action.payload.totalPages
      //   state.params = action.payload.params
      // })
      .addCase(getDataBookingDispatch.pending, (state) => {
        state.Loader = true
      })

      .addCase(getDataBookingDispatch.fulfilled, (state, action) => {
        
        state.Loader = false
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.RefreshConfirmedBooking = action.payload.data
      })
      
      // .addCase(getData.fulfilled, (state, action) => {

      //   state.data = action.payload.data
      //   state.params = action.payload.params
      //   state.total = action.payload.totalPages
      // })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      // .addCase(getClient.fulfilled, (state, action) => {

      //   state.selectedUser = action.payload.data[0]
      // })
  }
})

export const getDispatchLicenseTypes = createAsyncThunk('DispatchBookings/getDispatchLicenseTypes', async (params) => {
  const response = await axios.post(`${API_URL}/Vehicle/GetLicenseTypeList`, params, { mode: 'cors' })
  return response.data
})


export default BookingSlice.reducer
